export default "__VITE_ASSET__BxCVZjUo__"